export default __webpack_public_path__ + "static/media/Warning.fa711a22.svg";